import apiHandler from "../core/apiHandler";

const printerApi = apiHandler('printers');
export default printerApi;